import { render } from "./A11y.vue?vue&type=template&id=1f4662ec"
import script from "./A11y.vue?vue&type=script&lang=js"
export * from "./A11y.vue?vue&type=script&lang=js"
script.render = render

export default script